module.exports = require('../dist/components/Stack/Stack');
